import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { login } from "../../services/authService";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import Colors from "../../common/color";
import loginBackground from "../../assets/images/login-background.jpg";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { UAParser } from 'ua-parser-js';

const Login: React.FC = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const getDeviceFingerprint = async () => {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const fingerprint = result.visitorId;
        return fingerprint;
    };


    const handleLogin = async (req: { email: string, password: string }) => {
        try {
            setLoading(true);
            const ip = await getDeviceFingerprint();
            const parser = new UAParser();
            const browserName = parser.getBrowser().name;
            const osName = parser.getOS().name;
            const deviceType = parser.getDevice().type || 'desktop';
            const screenResolution = `${window.screen.width}x${window.screen.height}`;
            const device = {
                ip: ip,
                browser: browserName,
                os: osName,
                deviceType: deviceType,
                screenResolution: screenResolution,
            };
            const response = await login(req.email, req.password, device);
            if (response.token) {
                message.success("Sign in successfully!");
                if (response?.user?.isViewPolicy === '0' || response?.user?.isViewPolicy === 0) {
                    navigate("/terms-and-policy");
                } else {
                    navigate("/");
                }
            }
        } catch (error) {
            message.error(error.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="flex h-screen">
            {/* Left Section */}
            <div className="w-full md:w-1/2 bg-white flex flex-col justify-center items-center px-8">
                <h1 className="text-2xl font-bold mb-4">Welcome to Hien Le Aptis</h1>
                <p className="text-gray-500 mb-6">Please enter your account</p>
                <Form
                    form={form}
                    name="loginForm"
                    className="w-full max-w-sm"
                    onFinish={(values) => {
                        handleLogin(values);
                    }}
                >
                    <Form.Item>
                        <Form.Item
                            name="email"
                            rules={[{ required: true, message: "Please enter your email!" }]}
                        >
                            <Input
                                prefix={<UserOutlined className="text-gray-400" />}
                                placeholder="Email"
                                size="small"
                                className="h-12"
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: "Please enter your password!" }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined className="text-gray-400" />}
                                placeholder="Password"
                                size="small"
                                className="h-12"
                            />
                        </Form.Item>
                        <Button
                            type="primary"
                            size="large"
                            style={{ backgroundColor: Colors.primary }}
                            htmlType="submit"
                            className="w-full mb-4 rounded-md"
                            loading={loading}
                        >
                            Sign In
                        </Button>
                    </Form.Item>
                </Form>
            </div>

            {/* Right Section */}
            <div
                className="hidden md:flex w-1/2 bg-gradient-to-r from-orange-300 to-pink-400 items-center justify-center"
                style={{
                    backgroundImage: `url(${loginBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            ></div>
        </div>
    );
};

export default Login;
